import React, { useEffect, useRef, useState, version } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { toast } from "react-toastify";
import { jsPDF } from "jspdf";
import CoreBusinessLayout from "../../components/coreBusinessSideBar/CoreBusinessSideBar";
import InitialScreen from "./InitialScreen";
import { ApiConfig } from "../../services/ApiConfig";
import html2PDF from "jspdf-html2canvas";
import DownloadIcon from "@mui/icons-material/Download";
import dayjs from "dayjs";
import customAxios from "../../utils/customAxios";
import axios from "axios";
import { useSelector } from "react-redux";
import { color } from "@mui/system";
import html2pdf from "html2pdf.js";

const boxShadow = {
  fill: "#FFF",
  strokeWidth: "1px",
  stroke: "rgba(82, 49, 104, 0.25)",
  padding: "15px",
  width: "100%",
  position: "relative",
  height: "78vh",
  overflowY: "auto",
  boxShadow: "rgba(0, 0, 0, 0.07) 6px 1px 18px 5px",
};

function CoreBusinessDocument() {
  const [currentOption, setCurrentOption] = useState("initial");
  const [apiId, setApiId] = useState(sessionStorage.getItem("assessmentId"));
  const [reportData, setReportData] = useState([]);
  const [versionData, setVersionData] = useState({});
  const [currentVerision, setCurrentVersion] = useState(1);
  // const [currentVerision, setCurrentVersion] = useState("analysis-data");
  const [dashboardData, setDashboardData] = useState([]);
  const currentTheme = useSelector((state) => state.themeSwitcher.mode);
  const [pdfData, setPdfData] = useState();
  const location = useLocation();

  const assessmentName = location?.state?.assessmentName;
  console.log(location);

  // useEffect(() => {
  //   console.log(apiId, "asjakijsds");
  // }, [apiId]);

  const navigate = useNavigate();

  const getAssessmentData = async () => {
    try {
      const res = await customAxios({
        method: "GET",
        url: ApiConfig.findAllAssesmentMasterList,
        headers: {
          token: sessionStorage.getItem("userToken"),
        },
        params: {
          business_owner_id: sessionStorage.getItem("userId"),
        },
      });
      if (res.data.statusCode === 200) {
        console.log(res);
        setDashboardData(res?.data?.result?.assesmentDetails);
        console.log(res?.data?.result?.assesmentDetails, "assesmentDetails");
        if (!apiId) {
          setApiId(res?.data?.result?.assesmentDetails[0].id);
        } else {
          sessionStorage.removeItem("assessmentId");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAssessmentData();
  }, []);

  const handleGenerateReport = () => {
    if (Object.values(versionData).length > 0) {
      if (versionData[currentVerision][0].is_report_generated === true) {
        setCurrentOption(0);
      }
    } else {
      toast.warning("Please complete the assessment first.");
      navigate("/discovery-coaches");
    }
  };
  const text =
    'Upon analyzing the questions and answers provided in the dataset for Mission & Vision Assessment, several key themes emerge. These themes can help evaluate the alignment of these questions and answers with the overall Mission & Vision Assessment of your business.\n\nThe key themes identified in the questions include:\n\n1. Purpose and Goals: Questions related to the purpose and goals of the business, such as "What is the main purpose of our organization?" and "What are the long-term goals of our business?"\n\n2. Values and Culture: Questions concerning the values and culture of the organization, such as "What values do we prioritize?" and "How do we foster a positive work culture?"\n\n3. Stakeholders and Target Audience: Questions related to understanding and serving the stakeholders and target audience of the business, such as "Who are our key stakeholders?" and "How do we meet the needs of our target audience?"\n\n4. Competitive Advantage: Questions about the unique selling points and competitive advantage of the business, such as "What sets us apart from our competitors?" and "What is our unique value proposition?"\n\n5. Growth and Expansion: Questions concerning future growth and expansion plans, such as "What strategies do we have in place for business growth?" and "How do we plan to expand into new markets?"\n\n6. Sustainability and Social Impact: Questions about the organization\'s commitment to sustainability and social responsibility, such as "How do we minimize our environmental footprint?" and "What social initiatives do we support?"\n\nTo assess the alignment of these questions with your business\'s Mission & Vision Assessment, it is important to review the objectives and goals outlined in your Mission & Vision statements. Compare them with the questions to determine if they cover similar areas of focus.\n\nMoving on to the analysis of the answers, it is crucial to evaluate their relevance, comprehensiveness, and alignment with your business goals. Look for answers that directly address the questions, provide actionable insights, and align with the values and objectives of your organization.\n\nIdentifying common patterns or discrepancies in the answers can help identify areas of strength or improvement in your business\'s Mission & Vision Assessment. Look for consistent and well-supported answers that align with your goals, values, and competitive landscape.\n\nWhile you have mentioned uncertainty regarding the accuracy of the answers, you can still evaluate their quality based on your organization\'s expertise and knowledge. Consider involving domain experts or subject matter specialists within your business to assess the accuracy and reliability of the answers provided.\n\nIn conclusion, analyzing the questions and answers provided in the dataset, along with evaluating their alignment and accuracy, will enable you to gain valuable insights into your business\'s Mission & Vision Assessment. This analysis will help identify areas of strength, improvement, and potential gaps in your organization\'s Mission & Vision statements and strategies.';
  const lineFormat = text.replace(/\n\n/g, "<br><br>");
  const reportTemplateRef = useRef(null);

  // const handleDownload = async () => {
  //   const customWidth = 500;
  //   const customHeight = 660;
  //   const dataBox = document.getElementById("reportBox");
  //   html2PDF(dataBox, {
  //     jsPDF: {
  //       format: [customWidth, customHeight],
  //       margin: {
  //         top: 20,
  //         bottom: 20,
  //       },
  //     },
  //   });
  // };
  const getPdfData = async () => {
    try {
      const res = await axios({
        method: "GET",
        url: ApiConfig.getAllPdfLayout,
        headers: {
          token: sessionStorage.getItem("userToken"),
        },
      });
      if (res.data.statusCode === 200) {
        console.log(res?.data.result?.data[0], "dataaaaa");
        return res.data.result.data; // Return the data from the API
      }
      return []; // Return an empty array if no data is found
    } catch (error) {
      console.log("Error fetching PDF data:", error);
      return []; // Return an empty array on error
    }
  };

  const handleDownload = async () => {
    const dataBox = document.getElementById("reportBox");

    const opt = {
      margin: 0.5,
      filename: `${currentOption}_Version${currentVerision}.pdf`,
      image: { type: "jpeg", quality: 0.98 }, // This line is for optional image settings
      // html2canvas: { scale: 2 }, // Uncomment if needed, but may affect text selection
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    try {
      await html2pdf().from(dataBox).set(opt).save();
      console.log("PDF generated successfully!");
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  const handleReportData = async () => {
    try {
      const res = await customAxios({
        method: "POST",
        url: ApiConfig.findAnalysisData,
        headers: {
          token: sessionStorage.getItem("userToken"),
        },
        data: {
          business_owner_id: sessionStorage.getItem("userId"),
          user_type: sessionStorage.getItem("userType") || "BUSINESS_OWNER",
          assesment_master_id: apiId,
          version_control: currentVerision,
        },
      });
      if (res.data.statusCode === 200) {
        console.log(res?.data.result);
        setReportData(res?.data.result);
        const pdfData1 = await getPdfData();
        console.log(pdfData1);
        setPdfData(pdfData1[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (apiId) {
      handleReportData();
    }
  }, [currentOption, currentVerision, apiId]);

  useEffect(() => {
    getAssessmentVersion();
  }, [apiId]);

  const getAssessmentVersion = async () => {
    try {
      const res = await customAxios({
        method: "POST",
        url: ApiConfig.findAllAssesmentVersionControlListing,
        headers: {
          token: sessionStorage.getItem("userToken"),
        },
        data: {
          business_owner_id: sessionStorage.getItem("userId"),
          // assesment_id: sessionStorage.getItem("assessmentId"),
          assesment_id: apiId,
        },
      });
      if (res.data.statusCode === 200) {
        setVersionData(res.data.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAssessmentVersion();
    console.log(currentOption, "currentOption");
  }, [currentOption, apiId]);

  useEffect(() => {
    if (assessmentName) setCurrentOption(assessmentName);
  }, []);
  function addBoldTags(text) {
    const headingsPattern = /^(.*?:)$/gm;
    const headingsMatches = text.match(headingsPattern);
    // console.log(headingsMatches, "askazxjba");

    // if (headingsMatches) {
    //   headingsMatches.forEach((heading) => {
    //     text = text?.replace(new RegExp(`^(${heading}.*)$`, "gm"), "<b>$1</b>");
    //   });
    // }

    return text;
  }

  return (
    <CoreBusinessLayout
      setCurrentOption={setCurrentOption}
      currentOption={currentOption}
      assessmentName={assessmentName}
      setApiId={setApiId}
      apiId={apiId}
      style={{ color: currentTheme == "DARK" ? "#151515" : "#fff" }}
    >
      <Box style={boxShadow}>
        <Box
          sx={{
            width: "100%",
            height: "100px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",

            // px: { md: 6, sm: 1 },
          }}
        >
          {currentOption != "initial" &&
            Object.keys(versionData).length > 1 && (
              <FormControl
                style={{
                  height: "50px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  width: "180px",
                  // margin: "0 10px",
                  // position: "absolute",
                  // right: "200px",
                  // top: "30px",
                }}
              >
                <InputLabel
                  id="demo-simple-select-label"
                  style={{ color: currentTheme == "DARK" ? "#fff" : "#000" }}
                >
                  Version
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={currentVerision}
                  label="Version"
                  onChange={(e) => setCurrentVersion(e.target.value)}
                  sx={{
                    "& .MuiOutlinedInput-input": {
                      padding: "10px 14px!important",
                      color: currentTheme == "DARK" ? "#fff" : "#000",
                    },
                  }}
                >
                  {Object.keys(versionData).length > 0 &&
                    Object.values(versionData)
                      ?.filter((e, i) => e[0]?.is_report_generated)
                      .map((item, i) => {
                        return (
                          <MenuItem value={i + 1}>
                            V{i + 1}
                            <Typography
                              variant="body2"
                              display={"inline"}
                              ml={2}
                            >
                              {dayjs(item[0]?.updatedAt).format("ll")}
                            </Typography>
                          </MenuItem>
                        );
                      })}
                </Select>
              </FormControl>
            )}
          {currentOption != "initial" && reportData?.length > 0 && (
            <Button
              variant="contained"
              sx={{
                background:
                  "linear-gradient(98deg, #e46703 -1.68%, #c7340d 103.45%)",
                // height: "43px",
                borderRadius: "10px",
                textTransform: "capitalize",
                padding: {
                  md: "10px 50px",
                  sm: "10px 30px",
                },
                marginBottom: "10px",
                // position: "absolute",
                // right: "30px",
                // top: "20px",
              }}
              onClick={() => handleDownload()}
            >
              <DownloadIcon />
              Download
              {/* <span
                style={{
                  fontSize: "16px",
                  margin: "0 0 0 10px",
                  padding: "4px 30px",
                }}
              >
                Download
              </span> */}
            </Button>
          )}
        </Box>
        <div
          ref={reportTemplateRef}
          style={{
            padding: "1rem",
            fontSize: "13px",
            width: " 100%",
            overflowY: "scroll",
          }}
          id="reportBox"
        >
          {currentOption === "initial" && (
            <h2
              style={{ position: "absolute", left: "30%", fontWeight: "500" }}
            >
              Please select an assesment to view the generated report.
            </h2>
          )}
          {currentOption !== "initial" &&
            (reportData?.length > 0 ? (
              reportData?.map((item, i) => (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      // marginTop: "100px",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                    }}
                  >
                    {" "}
                    {/* <h1 style={{ color: "#c74d0d" }}>{pdfData?.title}</h1> */}
                    <img width="100px" src="/images/boostlogo2.png" />
                    <h1 style={{ color: "#c74d0d" }}>
                      {currentOption ? currentOption : assessmentName}
                    </h1>
                    <div>
                      <span style={{ color: "#c74d0d" }}>
                        Email: {pdfData?.email}
                      </span>
                      <br />
                      <span style={{ color: "#c74d0d" }}>
                        Mobile:{pdfData?.mobileNumber}
                      </span>
                    </div>
                  </div>
                  <hr />
                  <p
                    style={{
                      // padding: "1rem",
                      // whiteSpace: "pre-line",
                      color: currentTheme == "DARK" ? "#fff" : "#000",
                    }}
                    key={i}
                    dangerouslySetInnerHTML={{
                      // __html: item?.analyzeData.replace(/\n\n/g, "<br><br>"),
                      __html: addBoldTags(item?.analyzeData),
                    }}
                  ></p>
                </>
              ))
            ) : (
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                width="100%"
                gap="22px"
              >
                {" "}
                <Box component="img" src="/images/nodata.png"></Box>
                <Typography
                  // variant="h2"
                  sx={{
                    fontSize: "20px",
                    // position: "absolute",
                    // left: "30%",
                    fontWeight: "600",
                    color: currentTheme == "DARK" ? "#fff" : "#000",
                    // "@media screen and (max-width: 1000px)": {
                    //   left: "10%",
                    //   fontWeight: "600",
                    // },
                  }}
                >
                  All Your Metrics Are Up To Date For Analysing!
                </Typography>
                <Typography
                  textAlign="center"
                  sx={{
                    width: {
                      sm: "30vw",
                      xs: "50vw",
                      color: currentTheme == "DARK" ? "#fff" : "#000",
                    },
                  }}
                >
                  Awesome! Perhaps you should look at our discovery & coaching
                  to see if there is anything else you should be updating.
                </Typography>
                <Box>
                  <Button
                    sx={{
                      background:
                        "linear-gradient(98deg, #E46703 -1.68%, #C7340D 103.45%)",
                      borderRadius: "10px",
                      fontSize: "18px",
                      paddingX: "40px",
                      paddingY: "10px",

                      textTransform: "none",
                    }}
                    // disabled={loading}
                    variant="contained"
                    type="submit"
                    onClick={() => navigate("/discovery-coaches")}
                  >
                    Discovery & Coaching
                  </Button>
                </Box>
              </Box>
            ))}
        </div>
      </Box>
    </CoreBusinessLayout>
  );
}

export default CoreBusinessDocument;
